export const print = (element, config = {}) => {
  const defaultConfig = {
    title: document.title,
    ...config,
  };

  const printWindow = window.open("", "_blank");

  printWindow.document.write(`
      <html>
        <head>
          <title>${defaultConfig.title}</title>
          <link href="/css/app.css" rel="stylesheet">
        </head>
        <body>
          ${element.innerHTML}
        </body>
      </html>
    `);

  printWindow.document.close();
  printWindow.focus();

  printWindow.onload = function () {
    printWindow.print();
    printWindow.close();
  };
};
